<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Component History</span>
      
       

     
      <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>

<div style="display: flex; flex-direction: column;">
  <span class="ttmodal__title" style="font-size: initial;font-weight: bold;">System: {{System | translate | async}} </span>
  <span class="ttmodal__title" style="font-size: initial;font-weight: bold;"> Component: {{CompName | translate | async}} </span>
</div>
  <div class="ttmodal__footer" style="height: 360px;overflow-y: auto;" *ngIf="historyList!=null">
    
        <table  class="table table--full-width table--striped table--hover">
          <thead>
            <tr>
              <!-- <th style="padding: 0px 24px">System</th>
              <th style="padding: 0px 24px" >Component</th> -->
              <!-- <th style="padding: 0px 24px" >Position</th> -->
              <th style="padding: 0px 24px" >Date</th>
              <th style="padding: 0px 24px" >Inspection Source</th>
              <th style="padding: 0px 24px" >Question</th>
              <th style="padding: 0px 24px" >Answer</th>
              <!-- <th style="padding: 0px 24px" >Result</th> -->
              <th style="padding: 0px 24px;width: 10%;" >% Worn</th>
              <th style="padding: 0px 24px" >CMU</th>
              <th style="padding: 0px 24px" >Residual</th>
              <th style="padding: 0px 24px" >Projected</th>
            </tr>
          </thead>
          <tbody>
         
              <ng-container *ngFor="let comp of historyList">
                <tr style="cursor: pointer;" (click)="OpenInspection(comp)">
                 <!-- <td>{{System}}</td>
                 <td>{{comp.CompName}}</td> -->
                 <!-- <td>POS</td> -->
                 <td>{{comp.Date |date: 'dd MMM yyyy'}}</td>
                 <!-- <td>{{comp.InspectionSource}}</td>  //thisis is equipment-->
                 
                 <td style="max-width: 250px;">{{comp.FormName}}</td>
                 <td style="max-width: 250px;">{{comp.QuestionName}}</td>
                 <td style="max-width: 250px;">{{comp.Answers}}</td>

                 <!-- <td>Result</td> -->
                 <td><span  class="Eval-{{ comp.Worn | wornPercentageToEval}}"
                  style="margin-right: 7px;padding: 7px 21px;">
                  <div>{{comp.Worn?.toFixed(1)}}%</div>
                </span></td>
                 <td>{{comp.CMU}}</td>
                 <td>{{comp.Residual}}</td>
                 <td>{{comp.Projected}}</td>
                </tr>
            </ng-container>
            
           
              
  
          </tbody>
      </table>
  </div>
  
</div>